


export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <span>&copy; {new Date().getFullYear()} RCITMS. All rights reserved.</span>
        <span className="designed-by">
          Designed & Developed by{" "}
          <a href="https://magnusideas.com/" target="_blank" rel="noopener noreferrer">
            Magnus Ideas Pvt. Ltd.
          </a>
        </span>
      </div>
    </footer>
  );
}